// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import type { ToggleSystemGridType } from '../../types/actions';
import Toggle from '../buttons/Toggle';

const Wrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 3em;
  text-align: right;
  cursor: pointer;
`;

const Span = styled.span`
  color: #fff;
  margin: 0 0.2em 0 0;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type GridsSystemButtonProps = {
  className?: string;
  toggleSystem: ToggleSystemGridType;
  isSystem: boolean;
};

const GridsSystemButton = ({ className, toggleSystem, isSystem }: GridsSystemButtonProps) => {
  return (
    <Wrap className={className} onClick={toggleSystem}>
      <Span>{__('System grid')}</Span>
      <Toggle isChecked={isSystem} data-testid="grid-system-button" />
    </Wrap>
  );
};

export default GridsSystemButton;
